import { useBankruptcyEventsQuery } from "src/store/bankruptcyEvent";
import { useClassActionEventsQuery } from "src/store/classActionEvent";

export function useBankruptcyCounts() {
  const { data: upcoming } = useBankruptcyEventsQuery({
    tab: "upcoming",
    limit: 1,
  });
  const { data: active } = useBankruptcyEventsQuery({
    tab: "active",
    limit: 1,
  });
  const { data: recentlyCompleted } = useBankruptcyEventsQuery({
    tab: "recently_completed",
    limit: 1,
  });

  return {
    upcoming: upcoming?.count ?? 0,
    active: active?.count ?? 0,
    recentlyCompleted: recentlyCompleted?.count ?? 0,
  };
}

export function useClassActionCounts() {
  const { data: upcoming } = useClassActionEventsQuery({
    tab: "upcoming",
    limit: 1,
  });
  const { data: active } = useClassActionEventsQuery({
    tab: "active",
    limit: 1,
  });
  const { data: recentlyCompleted } = useClassActionEventsQuery({
    tab: "recently_completed",
    limit: 1,
  });

  return {
    upcoming: upcoming?.count ?? 0,
    active: active?.count ?? 0,
    recentlyCompleted: recentlyCompleted?.count ?? 0,
  };
}
